/**
 * Casa Mirari — tag search.
 *
 *  • Search box: "tag:polo", "#polo" or "tag:polo linen" opens the shop filtered by tag.
 *  • Any URL with ?tag=POLO (or ?tag=POLO,LINEN) redirects to the filtered shop.
 *  • While typing a tag query, a small "TAG · POLO" hint appears under the search field.
 *
 * Filtered URL: /collections/<handle>/polo+linen (legacy tag URL; no app filter needed)
 * Requires the "Tag" filter to be enabled in Shopify's Search & Discovery app.
 * Settings (Theme settings › Casa Mirari): collection handle, uppercase tags.
 */
(function () {
  'use strict';

  var cfg = window.casaMirari || {};
  var TAG_RE = /^\s*(?:tag:|#)\s*(.+)$/i;

  function normaliseTags(raw) {
    return String(raw)
      .split(/[\s,+]+/)
      .map(function (t) { return t.replace(/^#/, '').trim(); })
      .filter(Boolean)
      .map(function (t) { return cfg.tagUppercase === false ? t : t.toUpperCase(); });
  }

  function filterUrl(tags) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var handle = cfg.tagCollection || 'all';
    /* Legacy tag URL (/collections/all/polo+linen) works with or without the
       Search & Discovery "Tag" filter and ANDs multiple tags. */
    var path = tags.map(function (t) {
      return encodeURIComponent(t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
    }).join('+');
    return root + 'collections/' + encodeURIComponent(handle) + (path ? '/' + path : '');
  }

  /* 1 — ?tag=POLO shortcut on any page */
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.has('tag') && !(window.Shopify && window.Shopify.designMode)) {
      var tags = normaliseTags(params.getAll('tag').join(','));
      if (tags.length) window.location.replace(filterUrl(tags));
    }
  } catch (e) { /* URLSearchParams unsupported — ignore */ }

  /* 2 — search forms: intercept tag queries before Dawn's predictive search */
  function isSearchForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return /\/search\/?$/.test(action) && form.querySelector('input[name="q"]');
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isSearchForm(form)) return;
      var input = form.querySelector('input[name="q"]');
      var match = input && input.value.match(TAG_RE);
      if (!match) return;
      var tags = normaliseTags(match[1]);
      if (!tags.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = filterUrl(tags);
    },
    true
  );

  /* 3 — "TAG · POLO" hint while typing */
  function hintFor(form) {
    var hint = form.parentElement && form.parentElement.querySelector(':scope > .cm-tag-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'cm-tag-hint';
      hint.setAttribute('role', 'status');
      hint.innerHTML = '<span class="cm-tag-hint__chip"></span><span class="cm-tag-hint__text"></span>';
      form.insertAdjacentElement('afterend', hint);
    }
    return hint;
  }

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || input.name !== 'q') return;
    var form = input.closest('form');
    if (!isSearchForm(form)) return;
    var match = input.value.match(TAG_RE);
    var hint = hintFor(form);
    if (!match) { hint.classList.remove('is-active'); return; }
    var tags = normaliseTags(match[1]);
    if (!tags.length) { hint.classList.remove('is-active'); return; }
    var label = (cfg.strings && cfg.strings.tag) || 'Tag';
    hint.querySelector('.cm-tag-hint__chip').textContent = label + ' · ' + tags.join(' + ');
    hint.querySelector('.cm-tag-hint__text').textContent = '↵';
    hint.classList.add('is-active');
  });

  /* 4 — product page: when a colour (or any earlier option) changes and the
         current size isn't available in it, select the first available size
         before Dawn fetches the new variant (so image, price and stock update). */
  function groupsOf(picker) {
    return Array.prototype.slice.call(picker.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown'));
  }
  function valueOf(group) {
    var input = group.querySelector('input:checked');
    if (input) return input.value;
    var sel = group.querySelector('select');
    return sel ? sel.value : null;
  }
  function setValue(group, value) {
    var inputs = group.querySelectorAll('input[type="radio"]');
    if (inputs.length) {
      Array.prototype.forEach.call(inputs, function (i) { i.checked = i.value === value; });
      return;
    }
    var sel = group.querySelector('select');
    if (!sel) return;
    Array.prototype.forEach.call(sel.options, function (o) {
      var on = o.value === value;
      o.selected = on;
      if (on) o.setAttribute('selected', 'selected'); else o.removeAttribute('selected');
    });
  }
  document.addEventListener('change', function (event) {
    var picker = event.target.closest && event.target.closest('variant-selects');
    if (!picker) return;
    var data = picker.querySelector('script[data-cm-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var groups = groupsOf(picker);
    var changed = groups.findIndex(function (g) { return g.contains(event.target); });
    if (changed < 0) return;
    var current = groups.map(valueOf);
    var exact = variants.find(function (v) { return v.o.every(function (val, i) { return val === current[i]; }); });
    if (exact && exact.a) return;
    var candidates = variants.filter(function (v) {
      if (!v.a) return false;
      for (var i = 0; i <= changed; i++) if (v.o[i] !== current[i]) return false;
      return true;
    });
    if (!candidates.length) return;
    // prefer the candidate that keeps most of the other current choices
    candidates.sort(function (x, y) {
      var sx = 0, sy = 0;
      for (var i = changed + 1; i < current.length; i++) { if (x.o[i] === current[i]) sx++; if (y.o[i] === current[i]) sy++; }
      return sy - sx;
    });
    var pick = candidates[0];
    groups.forEach(function (g, i) { if (i !== changed) setValue(g, pick.o[i]); });
  }, true);
})();
